import request from '@/services/interceptor.js'


// Admin
export const get_userList = par => {
  return request({
    url: '/api/admin/users/' + par,
    method: 'get'
  })
};
export const save_userData = par => {
  return request({
    url: '/api/admin/users/save',
    method: 'post',
    data: par
  })
};
export const delete_user = par => {
  return request({
    url: '/api/admin/users/delete/' + par,
    method: 'delete'
  })
};
export const get_userNew = par => {
  return request({
    url: '/api/admin/usernew/' + par,
    method: 'get'
  })
};
export const delete_userNew = par => {
  return request({
    url: '/api/admin/usernew/delete/' + par,
    method: 'delete',
    noLoadingBar: true
  })
};
export const get_userNewValidate = par => {
  return request({
    url: '/api/admin/usernew/validate/' + par,
    method: 'get',
    noLoadingBar: true
  })
};
export const save_userNewConfirm = par => {
  return request({
    url: '/api/admin/usernew/confirm',
    method: 'post',
    data: par,
    noLoadingBar: true
  })
};
export const get_listaClienti = () => {
  return request({
    url: '/api/admin/clienti/lista',
    method: 'get',
    noLoadingBar: true
  })
};
export const get_listaRoles = () => {
  return request({
    url: '/api/admin/roles',
    method: 'get',
    noLoadingBar: true
  })
};
export const get_graficoAccessi = (par) => {
  return request({
    url: '/api/admin/accessi/' + par,
    method: 'get'
  })
}

//#region dashboard

export const get_menu = () => {
  return request({
    url: '/api/admin/manager/menu',
    method: 'get',
  })
};

export const disabilita_menu = (par) => {
  return request({
    url: '/api/admin/manager/updateMenu',
    method: 'post',
    data: par
  })
};

export const novita_menu = (par) => {
  return request({
    url: '/api/admin/manager/novitaMenu',
    method: 'post',
    data: par
  })
};

export const get_coppieAgenti = () => {
  return request({
    url: '/api/admin/manager/agenti',
    method: 'get',
  })
};

export const set_coppieAgenti = (par, data) => {
  return request({
    url: '/api/admin/manager/agenti/' + par,
    method: 'post',
    data: data,
  })
};

//#endregion



export const get_log_operazioni = () => {
  return request({
    url: '/api/admin/clienti/log',
    method: 'get'
  })
};